import React, { useEffect } from "react";
import _ from "lodash";
import cx from 'classnames';

import { animated, useSpring, useTransition } from "@react-spring/web";
import styles from "./styles.module.scss";
import { TabBar } from "src/components/tabbar";
import {  CollectionsBrowser,  StreamsBrowser } from "./browser";
import { useSelector } from "react-redux";
import { useAssetAdoption } from "src/redux/actions/adoption/asset";

interface AddAssetsFromHubProps {
  style: any;
  width: number;
  height?: number;
  // eslint-disable-next-line no-unused-vars
  onSelection: (entity: any) => void;
  selectedEntity:any;
  selectedEntities?: any[];
}

interface SelectEntityContextProps {
  selectedEntity : any;
  selectedEntities?: any[]; 
}

export const SelectEntityContext = React.createContext<SelectEntityContextProps>({
  selectedEntity: null,
  selectedEntities: []
});


const SelectEntity: React.FC<AddAssetsFromHubProps> = ({ style, width,height, onSelection , selectedEntity, selectedEntities }) => {
  const [query, setQuery] = React.useState<string | null>('');

  const browserTransition = useTransition(!query, {
    initial: { opacity: 1 },
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  return (
    <SelectEntityContext.Provider value={{ selectedEntities, selectedEntity }}>

    <animated.div className={cx(styles.hubAssets)} style={{ height: `${height}vh`,...style}}>
      <div className={cx(styles.stacks, styles.content)}>
        {browserTransition((style, item) => item && <AssetBrowser style={style} width={width} onSelection={onSelection} />)}
      </div>
    </animated.div>
    </SelectEntityContext.Provider>
  );
}

interface AssetBrowserProps {
  style: any;
  width: number;
  // eslint-disable-next-line no-unused-vars
  onSelection: (entity: any) => void;
  selected?: number;

}

const AssetBrowser: React.FC<AssetBrowserProps> = ({ style, width, onSelection }) => {
  const asset = useSelector((state: any) => _.get(state, 'asset.item', null));

  const {trackDestinationSelected} = useAssetAdoption();
  const [activeTab, setActiveTab] = React.useState(0);
 
  const handleSelection = (entity) => {
    onSelection(entity);
  }

  return (
    <animated.div style={style} className={cx(styles.assetBrowser, styles.stack)}>
      <TabBar className={cx(styles.tabs)} gap={32} tabSize="equal" active={activeTab} onSelectionChange={(tab) => setActiveTab(tab)}>
        <div className={cx(styles.tab, { [styles.active]: activeTab == 0 })}>Streams</div>
        <div className={cx(styles.tab, { [styles.active]: activeTab == 1 })}>Collections</div>
      </TabBar>
      <div className={cx(styles.stacks, styles.tabContainer)} style={{ width: width }}>
        <TabSection index={0} selected={activeTab}>
          <StreamsBrowser 
            width={width}
            selected={activeTab}
            action={entity => {
              return false;
            }}
            onSelection={handleSelection}
          />
        </TabSection>
        <TabSection index={1} selected={activeTab}>
          <CollectionsBrowser width={width}
             action={entity => {
              return false;
            }}
            onSelection={handleSelection}
          />
        </TabSection>
      </div>
    </animated.div>
  );
}


interface TabSectionProps {
  selected: number;
  index: number;
  children: React.ReactNode;
}

const TabSection: React.FC<TabSectionProps> = ({ index, selected, children }) => {
  const active = index === selected;
  const [animation] = useSpring({
    height: active ? 'auto' : 0,
    opacity: active ? 1 : 0,
    transform: active ? `translate3d(0,0,0)` : `translate3d(${100 * (index > selected ? 1 : -1)}%, 0, 0)`,
  }, [active]);

  return (
    <animated.div style={animation} className={cx(styles.tabBody, styles.stack)}>
      {children}
    </animated.div>
  );
}

export { SelectEntity };